import { Conversation } from 'types/conversation'
import { Message } from 'types/message'

export interface UnreadCampaign {
  conversation: Partial<Conversation>
  messages: Message[]
}

export interface ActiveCampaign {
  id: number,
  attributes: Record<string, any>,
  message?: Message,
  inboxId?: number
}

export interface CampaignsState {
  activeCampaign?: ActiveCampaign,
  campaignEvalId?: number,
  enrolledInteractionIds: number[]
  enrolledCampaignIds: number[],
  ineligibleCampaignIds: number[],
  unreadCampaigns: UnreadCampaign[],
  campaignConversations: Partial<Conversation>[]
}

export enum RenderBotCampaignResult {
  RENDERED,
  ENROLLED
}
